export default "__VITE_ASSET__c1160431__"